<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}">
      {{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.opinion.changedByOrg.p1')}}
    "
    <router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[2] }}"
    >{{ news.textParams[3] }}
    </router-link>
    "
    {{$t('news.template.opinion.changedByOrg.p2')}}
    "
    <router-link :to="{name: 'OpinionView', params: {hash: news.textParams[2] }}">
      {{ news.textParams[4] }}
    </router-link>
    "
  </div>
</template>
